import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

export const HS_CARD_ALERT_VARIANTS = {
  INSET: 'inset',
  OVERLAY: 'overlay',
};

const DEFAULT_ALERT_COLOR = '#9747ff';
const DEFAULT_ALERT_WIDTH = '16px';
const CARD_RADIUS = '16px';
const DEFAULT_CARD_MIN_HEIGHT = 151;

const toCssSize = (value) => (typeof value === 'number' ? `${value}px` : value);

const alertStyles = {
  // Stripe is part of the box and pushes the content.
  [HS_CARD_ALERT_VARIANTS.INSET]: css`
    border-left: ${(props) => props.$alertWidth} solid ${(props) => props.$alertColor};
  `,
  // Stripe is drawn over the content without shifting it.
  [HS_CARD_ALERT_VARIANTS.OVERLAY]: css`
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: ${(props) => props.$alertWidth};
      height: 100%;
      border-top-left-radius: ${CARD_RADIUS};
      border-bottom-left-radius: ${CARD_RADIUS};
      background: ${(props) => props.$alertColor};
    }
  `,
};

const StyledHSCard = styled.div`
  position: relative;
  background-color: #ffffff;
  border-radius: ${CARD_RADIUS};
  box-shadow: 6px 6px 20px 0px rgba(4, 76, 123, 0.2);
  ${(props) => props.$height && `height: ${props.$height};`}
  ${(props) => props.$minHeight && `min-height: ${props.$minHeight};`}

  &:hover {
    box-shadow: 6px 6px 2px 0px rgba(4, 76, 123, 0.3);
  }

  ${(props) => props.$showAlert && alertStyles[props.$alertVariant]}
`;

export const HSCard = ({
  content,
  showAlert = false,
  alertColor = DEFAULT_ALERT_COLOR,
  alertWidth = DEFAULT_ALERT_WIDTH,
  alertVariant = HS_CARD_ALERT_VARIANTS.INSET,
  height,
  minHeight = DEFAULT_CARD_MIN_HEIGHT,
  component,
  ...rest
}) => (
  <StyledHSCard
    as={component}
    $showAlert={showAlert}
    $alertColor={alertColor}
    $alertWidth={toCssSize(alertWidth)}
    $alertVariant={alertVariant}
    $height={toCssSize(height)}
    $minHeight={toCssSize(minHeight)}
    {...rest}
  >
    {content}
  </StyledHSCard>
);

HSCard.propTypes = {
  content: PropTypes.node,
  showAlert: PropTypes.bool,
  alertColor: PropTypes.string,
  alertWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  alertVariant: PropTypes.oneOf(Object.values(HS_CARD_ALERT_VARIANTS)),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  component: PropTypes.elementType,
};

export default HSCard;
